
<script setup>
    import { computed, reactive, onMounted } from 'vue'
    import { ref as databaseRef, onValue, update, push, child, set } from "firebase/database";
    import { listAll, ref, deleteObject } from "firebase/storage";
    import { useRoute } from 'vue-router'
    import HeaderComponent from "../../components/common/HeaderComponent.vue"
    import AddCorporateComponent from "../../components/administrator/AddCorporateComponent.vue"
    import DefaultModalComponent from '../../components/common/DefaultModalComponent.vue'
    import AdminBar from '../../components/administrator/AdminBar.vue'
    import PaginateComponent from 'vuejs-paginate-next'
    import Firebase from "../../firebase_settings/index.js"
    import Error from "../../firebase_settings/error.js"
    import utilFunctions from "../../firebase_settings/utils.js"

    const database = Firebase.database;
    const storage = Firebase.storage;
    const route = useRoute()

    //企業情報等のリアクティブオブジェクト
    const reactiveObj = reactive({
        //企業ID
        corporateObjects: [],
        //再描画キー
        renderKey: 0,
        //企業追加モーダルフラグ
        addModalFlag: false,
        //現在のページ
        currentPage: 1,
        //モーダルフラグ
        modalFlag: false,
        //モーダルに表示するメッセージ
        modalMessage: "",
        //モーダルに表示する注意メッセージ
        modalRedMessage: "",
        //ローディングフラグ
        loadingFlag: false,
        //企業の削除フラグ
        deleteFlag: false,
        //モーダルに表示する追加オブジェクト
        otherObject: {}
    })
    //1ページに表示する件数
    const perPage = 10;
    //各管理者に対して最小日時の管理者のみをピックアップ(keyはCorporateName、compareKeyはCreateDate)
    const uniqueByKeyWithCondition = (arr, key, compareKey) => {
        return Object.values(arr.reduce((accumulator, corporateObject) => {
             //無効なオブジェクトはスキップ
            if (!corporateObject || !corporateObject[key]) {
                return accumulator;
            }
            //初回時もしくはそれよりも最小のデータがあれば更新する
            if (!accumulator[corporateObject[key]] || corporateObject[compareKey] < accumulator[corporateObject[key]][compareKey]) {
                //ID（compareKey）が小さい方を残す
                accumulator[corporateObject[key]] = corporateObject;
            }
            return accumulator;
        }, {}));
    };
    //firebaseからログイン利用者の情報を取得
    const getCorporate = () => {
        //DBの取得したいパスを指定
        const getData = databaseRef(database, `LoginUser/`)
        //DBを取得
        onValue(getData, (snapshot) => {
            reactiveObj.corporateObjects = []
            const corporateList = (snapshot.val())
            for (let key in corporateList) {
                reactiveObj.corporateObjects.push({
                    'Id': key,
                    'Administorator': corporateList[key]['Administorator'],
                    'Agree': corporateList[key]['Agree'],
                    'Email': corporateList[key]['Email'],
                    'CorporateId': corporateList[key]['CorporateId'],
                    'CorporateName': corporateList[key]['CorporateName'],
                    'EditAuthority': corporateList[key]['EditAuthority'],
                    'CreateDate': corporateList[key]['CreateDate'],
                })
            }
            //重複した企業を排除
            reactiveObj.corporateObjects = uniqueByKeyWithCondition(reactiveObj.corporateObjects, 'CorporateName', 'CreateDate')
            //LatestHistory順に並べ替え
            reactiveObj.corporateObjects = reactiveObj.corporateObjects.sort((element, nextElement) => {
                return (element['CreateDate'] > nextElement['CreateDate']) ? -1 : 1;
            })
            reactiveObj.renderKey++
        })
    }
    //APIの実行
    const callUtilFunction = async (resultMessage, functionName, data) => {
        utilFunctions.callFirebaseFunction(functionName, data)
        .then(() => {
            if(functionName == "deleteUser"){
                //削除後にページ数が減った場合の調整
                adjustPagecount()
            }
            reactiveObj.loadingFlag = false
            showDefaultModal(resultMessage)
        })
        .catch((error) => {
            reactiveObj.loadingFlag = false
            showDefaultModal(Error.errorResult(error.details, route.name))
        })
    }
    //企業追加のモーダルウィンドウを開く際に実行
    const showAddModal = () => {
        //モーダルウィンドウを開く
        reactiveObj.otherObject = {
            //企業コードの一覧を重複なしで抽出
            corporateIdList : Array.from(new Set(reactiveObj.corporateObjects.map(element => element.CorporateId)))
        }
        reactiveObj.addModalFlag = true
    }
    //企業追加のモーダルウィンドウを閉じる際に実行
    const closeAddModal = async(editFlag, newCorporateObj) => {
        //モーダルウィンドウを閉じる
        reactiveObj.addModalFlag= false;
        //変更ボタンを押下した時
        if(editFlag) {
            reactiveObj.loadingFlag = true;
            await callUtilFunction('登録処理が完了しました。', 'registerAdmin', {
                corporateName: newCorporateObj.corporateName,
                userName: newCorporateObj.userName,
                corporateId: newCorporateObj.corporateId,
                adminEmail: newCorporateObj.adminEmail,
                contractEmail: newCorporateObj.contractEmail,
                planValue: newCorporateObj.planValue,
                payment: newCorporateObj.payment
            })
            clickCallback(1)
        };
        reactiveObj.otherObject = {};
    }
    //企業削除時に必要な情報をセットする
    const deleteDataSet = (data, key) => {
        //子コンポーネントに渡すオブジェクト
        reactiveObj.otherObject = {
            adminIndex: key,
            corporateId: data.CorporateId,
            confirm: '削除する',
            modalWidth: "35%",
        };
        const message = `以下の企業を削除します。<br>よろしいですか？<br><br>企業名：${data.CorporateName}`;
        reactiveObj.deleteFlag = true
        showDefaultModal(message)
    };
    //storageファイルの削除
    const deleteAllStorage = async (storagePath) => {
        const storageRef = ref(storage, storagePath);
        const listResult = await listAll(storageRef); //配下の全パス取得
        // ファイルを削除
        const deleteFilePromises = listResult.items.map((itemRef) => deleteObject(itemRef));
        // サブフォルダがある場合、再帰的に削除
        const deleteFolderPromises = listResult.prefixes.map((subFolderRef) =>
            deleteAllStorage(subFolderRef.fullPath)
        );
        await Promise.all([...deleteFilePromises, ...deleteFolderPromises]);
    }
    //モーダルウィンドウを開く際に実行
    const showDefaultModal = (message) => {
        //モーダルウィンドウを開く
        reactiveObj.modalFlag = true;
        //モーダルウィンドウに表示するメッセージを設定　※ここでHTMLの設定しないと反映できない
        reactiveObj.modalMessage = message;
        reactiveObj.modalRedMessage = reactiveObj.deleteFlag ? "※登録されている全ての管理者が削除されます。<br><br>" : "";
        //モーダルウィンドウを再描画
        reactiveObj.renderKey++;
    }
    //モーダルウィンドウを閉じる際に実行
    const closeDefaultModal = async (editFlag) => {
        //モーダルウィンドウを閉じる
        reactiveObj.modalFlag = false;
        //削除に同意しているか
        if(reactiveObj.deleteFlag && editFlag) {
            //削除対象の情報を取得
            const targetEmailList = []
            const corporateId = reactiveObj.otherObject.corporateId;
            const corporateData = databaseRef(database, `CorporateId/${corporateId}`);
            await new Promise((resolve, reject) => {
                onValue(
                    corporateData,
                    (snapshot) => {
                        if (snapshot.exists()) {
                            const value = snapshot.val();
                            const user = value?.User;
                            if (user != null) {  
                                const usersArray = Array.isArray(user) ? user : Object.values(user);
                                for (const u of usersArray) {
                                    const email = u?.Email;
                                    if(email.length > 0) targetEmailList.push(email);
                                }
                            }
                        }
                        resolve()
                    }, {onlyOnce: true});
            });
            //企業情報を削除
            await set(corporateData, {});
            //企業コードのリストを削除
            const corporateIdListData = databaseRef(database, `CorporateIdList/`);
            const corporateIdList = await new Promise((resolve) => {
                onValue(
                    corporateIdListData,
                    (snapshot) => {
                        const value = snapshot.val();
                        // 値が null/undefined の場合に備えて配列化
                        const list = Array.isArray(value) ? value : Object.values(value ?? {});
                        resolve(list.filter((Id) => Id !== corporateId));
                    }, {onlyOnce: true});
            });
            await set(corporateIdListData, corporateIdList)
            //企業コードに一致する全管理者を削除
            reactiveObj.corporateObjects.forEach(async (element) => {
                if(element.CorporateId == corporateId) {
                    targetEmailList.push(element.Email)
                    const AdminData = databaseRef(database, `LoginUser/${element.Id}`);
                    await set(AdminData, {});
                };
            });
            // storage内のファイルを削除
            const storagePath = `${corporateId}/`;
            await deleteAllStorage(storagePath);

            reactiveObj.loadingFlag = true;
            callUtilFunction('削除処理が完了しました', 'deleteUser', {
                targetEmailList: [...new Set(targetEmailList)],
                corporateId: corporateId,
                force: true
            })
        };
        /* 削除関連のオブジェクトを削除 */
        reactiveObj.otherObject = {};
        reactiveObj.deleteFlag = false;
        reactiveObj.modalRedMessage = ''

    }
    //ページネーションを押下した時
    const clickCallback = (pageNum) => {
        reactiveObj.currentPage = Number(pageNum);
    }
    //Nページ目に表示するドア情報を取得
    const getItems = computed(() => {
        let current = reactiveObj.currentPage * perPage;
        let start = current - perPage;
        return reactiveObj.corporateObjects.slice(start, current);
    })
    //現在のページ数を取得
    const getPageCount = computed(() => {
        return Math.ceil(reactiveObj.corporateObjects.length / perPage) ? Math.ceil(reactiveObj.corporateObjects.length / perPage) : 1
    })
    //削除後にページ数が減った場合の調整
    const adjustPagecount = async () => {
        //現在のページを再計算
        const maxPage = Math.ceil(reactiveObj.corporateObjects.length / perPage) ? Math.ceil(reactiveObj.corporateObjects.length / perPage) : 1
        //削除後にページ数が減った場合、現在のページ = 全体のページ数とする
        if (reactiveObj.currentPage > maxPage) {
            reactiveObj.currentPage = Number(maxPage);
            //モーダルウィンドウを再描画
            reactiveObj.renderKey++
        }
    }
    //コンポーネントがマウントされた後に実行
    onMounted(() => {
        //企業一覧を取得する
        getCorporate()
    })
</script>
<template>
    <!-- コメントアウト用 -->
    <HeaderComponent></HeaderComponent>
    <AdminBar></AdminBar>
    <main>
        <div id="loadingDisplay" class="loading" v-show="reactiveObj.loadingFlag">
            <div class="load-text load-blink">処理中...</div>
        </div>
        <div class="corporateList" :key="`${reactiveObj.renderKey}`">
            <div class="titleArea">
                <p class="title">企業一覧</p>
                <button id="addButton" @click="showAddModal">企業追加</button>
                <AddCorporateComponent
                    :otherObject="reactiveObj.otherObject"
                    v-show="reactiveObj.addModalFlag"
                    @executeMethod="closeAddModal">
                </AddCorporateComponent>
            </div>
            <div class="tableArea">
                <table class="commonTable">
                    <tbody>
                        <tr>
                            <th id="corporateName">企業名</th>
                            <th id="corporateCode">企業コード</th>
                            <th id="adminEmail">管理者</th>
                            <th id="administrator">管理者権限</th>
                            <th id="EditAuthority">編集権限</th>
                            <th id="agree">利用規約</th>
                            <th id="delete">削除</th>
                        </tr>
                        <tr v-for="(data, key) in getItems" :key="key">
                            <td>{{ data.CorporateName }}</td>
                            <td>{{ data.CorporateId }}</td>
                            <td>{{ data.Email }}</td>
                            <td>{{ data.Administorator ? "〇" : "×" }}</td>
                            <td>{{ data.EditAuthority ? "〇" : "×" }}</td>
                            <td>{{ data.Agree ? "〇" : "×" }}</td>
                            <td><button type="button" class="deleteButton" @click="deleteDataSet(data, (reactiveObj.currentPage-1)*perPage+key)"><img src="../../assets/delete.png" id="deletelIcon"></button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <DefaultModalComponent
                :key="reactiveObj.renderKey"
                :modalMessage="reactiveObj.modalMessage"
                :modalRedMessage="reactiveObj.modalRedMessage"
                :otherObject="reactiveObj.otherObject"
                v-show="reactiveObj.modalFlag"
                @executeMethod="closeDefaultModal">
            </DefaultModalComponent>
        </div>
        <div class="paginationArea">
            <PaginateComponent
                :page-count="getPageCount"
                :click-handler="clickCallback"
                :page-range="5"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :force-page="reactiveObj.currentPage">
            </PaginateComponent>
        </div>
    </main>
</template>

<style scoped>
    .corporateList {
        padding: 0 5% 0 25%;
        background-color: #e7e6e6;
    }
    #addButton {
        position: relative;
        display: flex;
        margin-left: auto;
        top: -40px;
        border: solid 3px #00AEEB;
        background: #00AEEB;
        color: #FFFFFF;
    }
    @media (max-width: 1150px) {
        .corporateList {
            padding: 0 5% 0 5%;
        }
        .tableArea {
            overflow-x: scroll;
        }
    }
</style>
